var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGoogle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.8,
    height: 29.8,
    viewBox: "0 0 29.8 29.8",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-1242 -150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buscar",
    transform: "translate(1242 150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M6.6,148.229,5.567,152.1l-3.791.08a14.926,14.926,0,0,1-.11-13.913h0l3.375.619,1.479,3.355a8.892,8.892,0,0,0,.084,5.987Z",
    transform: "translate(0 -130.22)",
    fill: "#fbbb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M275.94,208.176a14.894,14.894,0,0,1-5.312,14.4h0l-4.251-.217-.6-3.756a8.88,8.88,0,0,0,3.821-4.535h-7.967v-5.895H275.94Z",
    transform: "translate(-246.4 -196.059)",
    fill: "#518ef8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M52.961,317.919h0a14.9,14.9,0,0,1-22.452-4.558l4.829-3.953a8.862,8.862,0,0,0,12.77,4.537Z",
    transform: "translate(-28.733 -291.4)",
    fill: "#28b446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M51.369,3.43,46.542,7.382a8.86,8.86,0,0,0-13.063,4.639L28.625,8.048h0A14.9,14.9,0,0,1,51.369,3.43Z",
    transform: "translate(-26.958)",
    fill: "#f14336"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google.6723a670.svg";
export { ForwardRef as ReactComponent };